import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { Button, ButtonTypes } from '../components';
import theme from '../theme';
import { defaultScale, scaleText } from '../utils/scaling';

interface IProps {
  t: (s: string) => string;
  navigation: any;
}

class ForgotMyPinComponent extends React.PureComponent<IProps> {
  constructor(props) {
    super(props);
  }
  public render() {
    const { t } = this.props;
    return (
      <View style={styles.container}>
        <Text style={styles.forgotPinText}>{t('forgotPin')}</Text>
        <View style={styles.centerdContent}>
          <Text style={styles.forgotPinInstructionHeading}>
            {t('forgotPinInstructionHeading')}
          </Text>
          <Text style={styles.forgotPinInstruction}>
            {t('forgotPinInstruction')}
          </Text>
        </View>
        <Button
          title={t('back')}
          onPress={() => {
            this.props.navigation.pop();
          }}
          buttonType={ButtonTypes.OUTLINE}
          overrideFontStyles={styles.buttonText}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.WHITE,
    padding: defaultScale(15),
  },
  centerdContent: {
    flex: 1,
    justifyContent: 'center',
  },
  forgotPinText: {
    ...theme.textStyle.heading,
  },
  forgotPinInstruction: {
    ...theme.textStyle.bodyCopyReg,
    color: theme.GREY_MEDIUM,
  },
  forgotPinInstructionHeading: {
    ...theme.textStyle.heading,
    marginBottom: defaultScale(25),
  },
  buttonText: {
    fontFamily: theme.Custom700,
    fontSize: scaleText(16),
  },
});

export const ForgotMyPin = translate(['familyPlan'])(ForgotMyPinComponent);
